import React from "react";
import {
  Form,
  Input,
  Select,
  InputNumber,
  Checkbox,
  DatePicker,
  
} from "antd";

const { Option } = Select;
const { TextArea, Password } = Input;

export default function FormField({
  name,
  label,
  type = "text",
  required = false,
  placeholder,
  options = [],
  maxLength,
  min,
  max,
  rules = [],
  size = "large",
  disabled = false,
  style,
  prefix,
  suffix,
  addonBefore,
  addonAfter,
  rows = 3,
  allowClear = true,
  onChange,
  initialValue,
  format,
  ...rest
}) {

  const builtRules = [];

  if (required) {
    builtRules.push({
      required: true,
      message: `${label || name} is required`,
    });
  }

  if (type === "email") {
    builtRules.push({ type: "email", message: "Invalid email address" });
  }

  if (type === "url") {
    builtRules.push({ type: "url", message: "Invalid URL" });
  }

  if (type === "number" && min !== undefined) {
    builtRules.push({ type: "number", min, message: `Minimum value is ${min}` });
  }

  if (type === "number" && max !== undefined) {
    builtRules.push({ type: "number", max, message: `Maximum value is ${max}` });
  }

  const allRules = [...builtRules, ...rules];

  // 🔹 Normalize select options
  const normalizedOptions = options.map((opt) =>
    typeof opt === "string" ? { label: opt, value: opt } : opt
  );

  
  const fieldLabel =
    label && required ? (
      <span>
        {label}
        <span style={{ color: "#ff4d4f", marginLeft: 4 }}>*</span>
      </span>
    ) : (
      label
    );

  // 🔹 Render input based on type
  const renderInput = () => {
    switch (type) {
      case "select":
        return (
          <Select
            placeholder={placeholder || `— Select ${label} —`}
            size={size}
            disabled={disabled}
            allowClear={allowClear}
            onChange={onChange}
            getPopupContainer={(triggerNode) => triggerNode.parentElement}
            {...rest}
          >
            {normalizedOptions.map((opt) => (
              <Option key={opt.value} value={opt.value}>
                {opt.label}
              </Option>
            ))}
          </Select>
        );

      case "number":
        return (
          <InputNumber
            placeholder={placeholder}
            size={size}
            disabled={disabled}
            min={min}
            max={max}
            style={{ width: "100%" }}
            addonBefore={addonBefore}
            addonAfter={addonAfter}
            onChange={onChange}
            {...rest}
          />
        );

      case "textarea":
        return (
          <TextArea
            placeholder={placeholder}
            rows={rows}
            maxLength={maxLength}
            showCount={!!maxLength}
            size={size}
            disabled={disabled}
            allowClear={allowClear}
            
            {...rest}
          />
        );

      case "password":
        return (
          <Password
            placeholder={placeholder}
            size={size}
            disabled={disabled}
            prefix={prefix}
            maxLength={maxLength}
           
            {...rest}
          />
        );

      case "checkbox":
        return (
          <Checkbox
            disabled={disabled}
            onChange={(e) => onChange?.(e.target.checked)}
            {...rest}
            getPopupContainer={(triggerNode) => triggerNode.parentElement}
          >
            {label}
          </Checkbox>
        );

      case "date":
        return (
          <DatePicker
            style={{ width: "100%", zIndex:99999 }}
            size={size}
            disabled={disabled}
            placeholder={placeholder || "Select date"}
            format={format || "YYYY-MM-DD"}
           getPopupContainer={() => document.body}
            {...rest}
          />
        );

      case "month":
        return (
          <DatePicker
          getPopupContainer={(triggerNode) => triggerNode.parentElement}
            picker="month"
            style={{ width: "100%" }}
            size={size}
            disabled={disabled}
            placeholder={placeholder || "Select month"}
            format={format || "YYYY-MM"}
            
            {...rest}
          />
        );

      case "year":
        return (
          <DatePicker
            picker="year"
            style={{ width: "100%" }}
            size={size}
            getPopupContainer={(triggerNode) => triggerNode.parentElement}
            disabled={disabled}
            placeholder={placeholder || "Select year"}
            format={format || "YYYY"}
         
            {...rest}
          />
        );

      default:
        return (
          <Input
            placeholder={placeholder}
            size={size}
            disabled={disabled}
            prefix={prefix}
            suffix={suffix}
            addonBefore={addonBefore}
            addonAfter={addonAfter}
            maxLength={maxLength}
            allowClear={false}
           
            {...rest}
          />
        );
    }
  };

  return (
    <Form.Item
      name={name}
      label={type !== "checkbox" ? fieldLabel : undefined}
      rules={allRules}
      initialValue={initialValue}
      style={style}
      requiredMark={false} 
      valuePropName={type === "checkbox" ? "checked" : "value"}
    >
      {renderInput()}
    </Form.Item>
  );
}
